const shareData = [
  {
    path: 'url',
    label: 'Collection URL',
    icon: 'material-symbols:link',
  },
  {
    path: 'embed',
    label: 'Embed on a website',
    icon: 'material-symbols:code',
  },
]

export default shareData
